/**
 * CrmProposalTypePicker — step 1 of new-proposal: choose Basic Services or Design Consultation.
 * Gated by what's already executed on the opportunity: we never issue two of the same type, and a
 * Design Consultation is a feeder for Basic Services, so once a DC is executed the only path is BS.
 */
import CrmModal from './CrmModal.jsx'

export default function CrmProposalTypePicker({ hasExecutedDC, hasExecutedBS, onPick, onClose }) {
  const types = []
  if (!hasExecutedBS) types.push('Basic Services')
  if (!hasExecutedDC && !hasExecutedBS) types.push('Design Consultation')

  return (
    <CrmModal title="New proposal" onClose={onClose} width={540}>
      <div style={S.intro}>What kind of proposal are you preparing?</div>

      {types.length === 0 ? (
        <div style={S.note}>This opportunity already has an executed Basic Services agreement, so a new proposal isn't needed.</div>
      ) : (
        <div style={S.cards}>
          {types.includes('Basic Services') && (
            <button style={S.card} onClick={() => onPick('Basic Services')}>
              <div style={S.cardTitle}>Basic Services</div>
              <div style={S.cardDesc}>Full architectural services with a defined scope: phased fees, design suites, and the complete agreement.</div>
            </button>
          )}
          {types.includes('Design Consultation') && (
            <button style={S.card} onClick={() => onPick('Design Consultation')}>
              <div style={S.cardTitle}>Design Consultation</div>
              <div style={S.cardDesc}>Open-ended consultation on a retainer when the scope isn't yet clear. Often feeds a later Basic Services proposal.</div>
            </button>
          )}
        </div>
      )}

      {hasExecutedDC && !hasExecutedBS && (
        <div style={S.note}>A Design Consultation has already been executed here, so the next step is Basic Services. We don't issue two of the same type.</div>
      )}
    </CrmModal>
  )
}

const S = {
  intro: { fontFamily: '"DM Sans", sans-serif', fontSize: 13.5, color: 'var(--aj-text)', marginBottom: 16 },
  cards: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 },
  card: { textAlign: 'left', background: 'var(--aj-bg-elevated)', border: '0.5px solid var(--aj-border-mid)', borderRadius: 10, padding: '16px 16px', cursor: 'pointer' },
  cardTitle: { fontFamily: '"Montserrat", sans-serif', fontSize: 14, fontWeight: 600, color: 'var(--aj-text)', marginBottom: 6 },
  cardDesc: { fontFamily: '"DM Sans", sans-serif', fontSize: 12, color: 'var(--aj-text-mid)', lineHeight: 1.5 },
  note: { fontFamily: '"DM Sans", sans-serif', fontSize: 12, color: 'var(--aj-text-mid)', background: 'var(--aj-bg-subtle)', borderRadius: 6, padding: '10px 12px', marginTop: 14, lineHeight: 1.5 },
}
